import React, { useState, useEffect } from 'react';
import './Gallery.css';
import galleryImage1 from '../assets/g1.jpg';
import galleryImage2 from '../assets/g2.jpg';
import galleryImage3 from '../assets/g3.jpg';
import galleryImage4 from '../assets/g4.jpg';
import galleryImage5 from '../assets/g5.jpg';
import galleryImage6 from '../assets/g6.jpg';


const Gallery = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const galleryImages = [
    {
      id: 1,
      src: galleryImage1,
      alt: "Panner Tikka",
      title: "Panner Tikka",
      description: "Panner Tikka is a traditional Indian dish made with panner and spices."
    },
    {
      id: 2,
      src: galleryImage2,
      alt: "Fish Fry",
      title: "Fish Fry",
      description: "Fish Fry is a traditional Indian dish made with fish and spices."
    },
    {
      id: 3,
      src: galleryImage3,
      alt: "Chicken Curry",
      title: "Chicken Curry",
      description: "Chicken Curry is a traditional Indian dish made with chicken and spices."
    },
    {
      id: 4,
      src: galleryImage5,
      alt: "Mushroom Curry",
      title: "Mushroom Curry",
      description: "Mushroom Curry is a traditional Indian dish made with mushrooms and spices."
    },
    {
      id: 5,
      src: galleryImage4,
      alt: "Biryani",
      title: "Biryani",
      description: "Biryani is a traditional Indian dish made with rice and spices."
    },
    {
      id: 6,
      src: galleryImage6,
      alt: "Masala Dosa",
      title: "Masala Dosa",
      description: "Masala Dosa is a traditional Indian dish made with rice and spices. "
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [galleryImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="gallery" id="gallery">
      <div className="gallery-container">
        {/* Section Header */}
        <div className="gallery-header">
        
          <h2 className="gallery-title">
            A Visual Feast of Authentic Indian Cuisine
          </h2>
          <p className="gallery-subtitle">
            Discover the vibrant colors, rich textures, and exquisite presentation 
            of our traditional Indian dishes, each telling a story of culinary heritage.
          </p>
        </div>

        {/* Gallery Slider */}
        <div className="gallery-slider">
          <div className="slider-wrapper">
            <div 
              className="slider-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {galleryImages.map((image, index) => (
                <div key={image.id} className="slide">
                  <div className="slide-image">
                    <img src={image.src} alt={image.alt} />
                    <div className="slide-overlay">
                      <div className="slide-content">
                        <h3 className="slide-title">{image.title}</h3>
                        <p className="slide-description">{image.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button className="slider-nav prev" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="slider-nav next" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </button>

          {/* Dots Indicator */}
          <div className="slider-dots">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
